<template lang="html">
  <div class='logoWarpper'>
    <a :href='href' class='logoWarpper_link'>
      <img
        v-if="showWhite"
        src="~@/assets/header_logo.png"
        class="logo"
        alt="小猴编程"
        title="小猴编程"
      />
      <img
        v-else
        src="~@/assets/header_logo.png"
        class="logo"
        alt="小猴编程"
        title="小猴编程"
      />
      <div class="logoWarpper_line"></div>
      <span class="logoWarpper_title">{{this.title}}</span>
    </a>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'Logo',
  props: {
    showWhite: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed:{
    href(){
      const {
        VUE_APP_ENV,
      } = process.env;
      const path = VUE_APP_ENV === 'production' 
        ? 'https://xiaohoucode.com/' 
        : (VUE_APP_ENV === 'preview' 
        ? 'https://pre.xiaohoucode.com/'
        : 'https://test.xiaohoucode.com/');
      return path;
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.logo {
  display: inline-block;
  width: 111px;
  height: auto;
  vertical-align: middle;
}
.logoWarpper {
  display: flex;
  align-items: center;
  pointer-events: all;
  &_link{
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;
  }
  &_line {
    width:2px;
    height:16px;
    background:rgba(255,255,255,1);
    border-radius:2px;
    margin: 0px 8px;
  }
}
.logoWarpper_title {
  font-size:18px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height: 23px;
}
</style>
